import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'utils/isNil';
import { colorTypeHelper } from 'utils/colorUtility';
import WebsiteImage from 'components/WebsiteImage';
import Cards from 'components/Core/Cards';
import Text from 'components/Core/Text';
import ContentfulCallToAction from 'components/Contentful/ContentfulCallToAction';
import { chunk } from 'utils/chunk';
import Bookmark from 'components/Page/Toolbox/Bookmark';
import { getCategory, getExcerpt, getImageSrc, getTitle } from 'components/Page/Toolbox/utils';
import { CardSectionLayout } from './styles';

const CallToActionCards = (props) => {
  const {
    title,
    cardType,
    bodyType,
    cardInfo,
    backgroundColor,
    textColor,
    subHeading,
    subTitle,
    subDescription,
    subLogos,
    cols,
    hubType,
    industry,
    cta,
    ...otherProps
  } = props;
  let renderCards = cardInfo;

  const fontColor = textColor
    ? textColor
    : backgroundColor === 'White' || backgroundColor === 'Skyline 1'
    ? 'var(--darkest)'
    : 'white';

  const tmpCol = cols === 0 || !cols ? renderCards?.length : cols;
  renderCards =
    renderCards &&
    renderCards.concat(
      Array(renderCards.length % tmpCol > 0 ? tmpCol - (renderCards.length % tmpCol) : 0).fill(
        null,
      ),
    );
  const cardsRow = renderCards && chunk(renderCards, tmpCol);

  return (
    <CardSectionLayout
      data-testid="ctaCards-container"
      className="st-cta-cards-section"
      backgroundColor={colorTypeHelper[backgroundColor]}
      {...otherProps}
    >
      <div style={{ textAlign: 'center' }}>
        {title && (
          <Text
            data-testid="ctaCards-title"
            type="p"
            color={fontColor}
            className="cards-title font-h2"
          >
            {title}
          </Text>
        )}
        {!isNil(subHeading) && (
          <Text
            type="p"
            color={fontColor}
            data-testid="ctaCards-description"
            className="section-description"
          >
            {subHeading.description}
          </Text>
        )}

        {cardsRow && (
          <div className="card-container" data-testid="ctaCards-card-container">
            {cardsRow.map((row, index) => (
              <div className="card-row-container" key={index}>
                {row.map((item, index1) => {
                  const renderItem = item?.node || item;
                  const path = renderItem?.seo?.pageUrl;
                  const hasStats = renderItem?.stats;
                  const ctaLink = path || renderItem?.ctaLink;
                  const coverImage = getImageSrc(renderItem);
                  const title = getTitle(renderItem);
                  const description = getExcerpt(renderItem);
                  const category = getCategory(renderItem);

                  return (
                    <div
                      className={`card-item ${tmpCol === 4 ? 'simple-responsive' : ''} ${
                        !renderItem ? 'empty' : ''
                      }`}
                      key={`card-item${renderItem?.id}${index1}`}
                    >
                      {renderItem &&
                        (cardType === 'Image' ? (
                          <Bookmark
                            subTitle={category}
                            url={ctaLink}
                            title={renderItem.title}
                            image={coverImage}
                            data={renderItem}
                          >
                            <Cards
                              type={'Image'}
                              bodyType={hasStats ? 'stat' : bodyType || 'blog'}
                              coverImage={coverImage}
                              category={category}
                              title={title}
                              description={description}
                              ctaTitle={
                                bodyType
                                  ? bodyType === 'simple'
                                    ? null
                                    : 'Learn more'
                                  : renderItem.ctaText
                              }
                              ctaLink={ctaLink}
                              author={renderItem.name}
                              percent={renderItem.stats}
                              statCaption={renderItem.statCaption}
                              coverBackColor={renderItem.backColor}
                              showFullDescription={item?.showFullDescription}
                              simpleResponsive={tmpCol === 4}
                            />
                          </Bookmark>
                        ) : cardType === 'Press' ? (
                          <Cards
                            bodyType={'simple'}
                            category={renderItem.postDate}
                            title={renderItem.postTitle}
                            description={renderItem?.seo?.metaDescription?.metaDescription}
                            ctaTitle={'Learn more'}
                            ctaLink={ctaLink}
                          />
                        ) : (
                          <Cards
                            type={cardType}
                            coverVideo={renderItem.wistiaVideo || renderItem.coverWistiaVideo}
                            description={item?.description?.description}
                            author={renderItem.name}
                            percent={renderItem.stats}
                            statCaption={renderItem.statCaption}
                          />
                        ))}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        )}

        {cta && (
          <div className="section-cta" data-testid="ctaCards-cta">
            <ContentfulCallToAction
              data-position="Body Card Block - CTA"
              buttonClass="section-cta--button"
              {...cta}
            />
          </div>
        )}
      </div>
      {!isNil(subTitle) && (
        <div className="section-bottom">
          <Text
            data-testid="ctaCards-bottom-title"
            type="h2"
            className="section-bottom-title"
            color={fontColor}
          >
            {subTitle}
          </Text>
          {subLogos && (
            <div data-testid="ctaCards-logos" className="bottom-logo-wrapper">
              {subLogos.map((img, index) => {
                return (
                  <div className="logo-content" key={index}>
                    <WebsiteImage image={img} alt={img.title} />
                  </div>
                );
              })}
            </div>
          )}
          {subDescription && (
            <Text
              data-testid="ctaCards-subdescription"
              type="p"
              className="section-bottom-description"
              color={fontColor}
            >
              {subDescription?.subDescription}
            </Text>
          )}
        </div>
      )}
    </CardSectionLayout>
  );
};

CallToActionCards.propTypes = {
  title: PropTypes.string,
  subHeading: PropTypes.object,
  backgroundColor: PropTypes.string,
  cardType: PropTypes.string,
  cardInfo: PropTypes.array,
  subTitle: PropTypes.string,
  statCaption: PropTypes.string,
  subDescription: PropTypes.object,
  subLogos: PropTypes.array,
  cols: PropTypes.number,
};

CallToActionCards.defaultProps = {
  cols: 0,
};

export default CallToActionCards;
